(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rangona-promo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rangona-promo-slider')) {
  customElements.define('rangona-promo-slider', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.rangona-story-slider__track');
      this.slides = Array.from(this.track.children);
      this.dots = Array.from(this.querySelectorAll('[data-slide]'));
      this.current = 0;
      const go = (index, smooth = true) => {
        index = Math.max(0, Math.min(this.slides.length - 1, index));
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
      };
      const sync = () => {
        this.current = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
        this.slides.forEach((slide, i) => { slide.inert = i !== this.current; });
      };
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => go(i), { signal }));
      this.track.addEventListener('scroll', sync, { passive:true, signal });
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        go(this.current + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      let drag = null;
      let suppressClick = false;
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { x:event.clientX, left:this.track.scrollLeft, id:event.pointerId };
        suppressClick = false;
      }, { signal });
      this.track.addEventListener('pointermove', event => {
        if (!drag) return;
        const distance = event.clientX - drag.x;
        if (Math.abs(distance) > 6) {
          suppressClick = true;
          this.track.setPointerCapture(drag.id);
          this.track.classList.add('is-dragging');
          this.track.scrollLeft = drag.left - distance;
        }
      }, { signal });
      const finish = () => {
        if (!drag) return;
        drag = null;
        this.track.classList.remove('is-dragging');
        go(Math.round(this.track.scrollLeft / this.track.clientWidth));
      };
      window.addEventListener('pointerup', finish, { signal });
      this.track.addEventListener('pointercancel', finish, { signal });
      this.track.addEventListener('click', event => {
        if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; }
      }, { capture:true, signal });
      this.resize = new ResizeObserver(() => go(this.current, false));
      this.resize.observe(this.track);
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('.rangona-promo');
        const index = this.slides.indexOf(slide);
        if (index >= 0) go(index, false);
      }, { signal });
      sync();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
